import React from 'react';
import uisFetch from '../../utils/uisFetch';
import { fetchAndConvertToBase64 } from '../../utils/FileUtils';
import config from "../../config"

function stripSurroundingQuotes(filename) {
    if (typeof filename !== 'string') {
        return filename;
    }

    if (filename.length >= 2 &&
        filename.startsWith('"') &&
        filename.endsWith('"')) {
        return filename.substring(1, filename.length - 1);
    }

    return filename;
}

class Application extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ern: ''
            , staff: {}
            , searchStaffResult: ''
            , requestOTPResult: ''
            , inputOTPResult: ''
            , otp: ''
            , request: {}
            , replaceReason: []
            , replaceItems: []
            , specialItems: []
            , allowSave: false
            , needEvidence: false
            , submitResult: ''
            , statusBusy: false
            , UploadAlert: "Choose File"
            , infoEntered: false
            , Source: [".pdf", ".png", ".jpg", ".jpeg", ".gif"]
            , SizeLimitInMB: 6
            , IsTabletView: Boolean
            , IsMobileView: Boolean
            , IsSmMobileView: Boolean
            , modelTitle: ''
            , modelImgIds: {}
            , modelUniformID: ''
            , existManItm: 0
            , loginResult: ''
            , isMicrosoftLogin: false
            , userData: null
            , measurementImages: {}
            , uniformdownloadattachement: {}
            , viewattachment: {}
            , loadingImages: {} 
            , imageLoadTimestamps: {} 
        }

       
        this.REQUEST_COOLDOWN = 5000; 

    }

    componentWillUnmount() {
        this.setState({
            measurementImages: {},
            uniformdownloadattachement: {},
            viewattachment: {},
            loadingImages: {},
            imageLoadTimestamps: {}
        });
    }

    
    handleMicrosoftLogin = (userData) => {
        this.setState({
            statusBusy: true,
            loginResult: "Verifying...",
            userData: userData,
            isMicrosoftLogin: true
        });

        const url = this.props.apiprefix + 'pubreqlogin';

        uisFetch(this.props.accessToken,url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.props.accessToken
            },
            body: JSON.stringify({
                LoginId: ''
            })
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json();
            } else {
                const error = new Error(response.statusText);
                const errResult = {
                    "sess": "",
                    "UserLevel": -999,
                    "Result": "ERROR: " + response.status
                };
                return JSON.parse(JSON.stringify(errResult));
            }
        }).then((data) => {
            console.log(data);
            this.setState({
                statusBusy: false,
                loginResult: data.Result
            });

            if (data.Result === "OK") {
                this.setState({
                    ern: data.LoginId,
                    otp: data.sess,
                    infoEntered: true
                }, () => {
                    setTimeout(() => {
                        $('#btnCollapseOneContinue').click();
                    }, 5);
                });
            } else {
                $('#logoutModal').modal('show');
                // After showing the modal, redirect if no permission
                setTimeout(() => {
                    window.location.href = process.env.PUBLIC_URL || "/";
                }, 3000); // Wait 3 seconds before redirect
            }
        }).catch((error) => {
            this.setState({
                statusBusy: false,
                loginResult: "Login failed: " + error.message
            });
        });
    }

    componentDidMount() {
        if (this.props.debug) console.log("[Application] componentDidMount - started");

        // Check permission first
        if (this.props.hasPermission === false) {
            // No permission, redirect to home page
            window.location.href = process.env.PUBLIC_URL || "/";
            return;
        }

        // Check if Microsoft login user data is available
        if (this.props.userData) {
            // If Microsoft login user data exists, automatically proceed with verification
            this.handleMicrosoftLogin(this.props.userData);
        } else {
            this.setState({
                infoEntered: false,
                loginResult: "等待微软登录..."
            });
        }

        this.setState({ IsMobileView: window.innerWidth <= 1024 });
        this.setState({ IsTabletView: window.innerWidth >= 768 });
        this.setState({ IsSmMobileView: window.innerWidth <= 375 });
        window.addEventListener('resize', () => {
            this.setState({
                IsMobileView: window.innerWidth <= 1024
            });
            this.setState({
                IsTabletView: window.innerWidth >= 768
            });
            this.setState({
                IsSmMobileView: window.innerWidth <= 375
            });
        }, false);

        window.onscroll = () => {
            var navbar = document.getElementById("uiReplacement");
            var sticky = navbar.offsetTop;
            if (window.pageYOffset >= sticky) {
                navbar.classList.add("sticky");
                navbar.children.classList.add("small");
                children = parent.children;
            } else {
                navbar.classList.remove("sticky");
                navbar.children.classList.remove("small");
            }
        }
    }

    loadReplacementReason() {
        const url = this.props.apiprefix + 'pubreqgetreplacereason?otp=' + this.state.otp;
        uisFetch(this.props.accessToken,url, {
            method: "GET",
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] searchErn - result");
            if (this.props.debug) console.log(result)
            this.setState({ replaceReason: result })
        });
    }

    loadReplacementItems() {
        const url = this.props.apiprefix + 'pubreqgetreplaceitems?otp=' + this.state.otp;
        uisFetch(this.props.accessToken,url, {
            method: "GET",
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] searchErn - result");
            if (this.props.debug) console.log(result)

            let _replaceItems = [];

            result.forEach((m) => {
                let _position = _replaceItems.findIndex((e) => e.UniformID == m.UniformID);
                if (_position >= 0) // Same Uniform Code founded, update on-hold subcode information only
                {
                    let _subCodeNode = new Object();
                    _subCodeNode.SubCodeID = m.SubCodeID;
                    _subCodeNode.SubCode = m.SubCode;
                    _subCodeNode.SubCodeDesc = m.SubCodeDesc;
                    _subCodeNode.SubCodeDescZh = m.SubCodeDescZh;
                    _subCodeNode.SubCodeCollectedQty = m.SubCodeCollectedQty;

                    _replaceItems[_position].SubCodeList.push(_subCodeNode);
                    //_replaceItems[_position].ReplaceableQty  += m.ReplaceableQty;

                }
                else {
                    let _uniformCodeNode = new Object();
                    _uniformCodeNode.UniformID = m.UniformID;
                    _uniformCodeNode.UniformCode = m.UniformCode;
                    _uniformCodeNode.UniformDesc = m.UniformDesc;
                    _uniformCodeNode.UniformDescZh = m.UniformDescZh;
                    _uniformCodeNode.UnitDesc = m.UnitDesc;
                    _uniformCodeNode.UnitDescZh = m.UnitDescZh;

                    let _subCodeNode = new Object();
                    _subCodeNode.SubCodeID = m.SubCodeID;
                    _subCodeNode.SubCode = m.SubCode;
                    _subCodeNode.SubCodeDesc = m.SubCodeDesc;
                    _subCodeNode.SubCodeDescZh = m.SubCodeDescZh;
                    _subCodeNode.SubCodeCollectedQty = m.SubCodeCollectedQty;
                    _uniformCodeNode.SubCodeList = [];
                    _uniformCodeNode.SubCodeList.push(_subCodeNode);

                    _uniformCodeNode.SubCodeOptions = m.SubCodeOptions;
                    _uniformCodeNode.ReplaceableQty = m.ReplaceableQty;
                    _uniformCodeNode.MaxReplacementCount = m.MaxReplacementCount;
                    _uniformCodeNode.CurrentReplacementCount = m.CurrentReplacementCount;
                    _uniformCodeNode.NeedEvidenceList = m.NeedEvidenceList;
                    _uniformCodeNode.Seq = m.Seq;
                    _uniformCodeNode.ImageList = m.ImageList;
                    _uniformCodeNode.IsManItem = m.IsManItem;
                    _replaceItems.push(_uniformCodeNode);
                }
            }
            );

            this.setState({ replaceItems: _replaceItems });
        });
    }

    loadSpecialItems() {
        const url = this.props.apiprefix + 'pubreqgetspecialitems?otp=' + this.state.otp;
        uisFetch(this.props.accessToken,url, {
            method: "GET",
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] searchErn - result");
            if (this.props.debug) console.log(result)
            this.setState({ specialItems: result })
        });
    }

    validateSave() {
        let _canSave = true;

        this.setState({ needEvidence: false });

        if (!this.state.request) {
            _canSave = false;
        } else {
            const request = this.state.request;
            if (request.Status !== 'B')
                _canSave = false;
            else if (!request.RequestItems)
                _canSave = false;
            else if (request.RequestItems.length === 0)
                _canSave = false;

            if (request.RequestType === 'S' && (request.Attachments.length <= 0))
                _canSave = false;

            let _checker = 0;
            request.RequestItems.find((node) => {
                if (this.props.debug) console.log(node)
                if (!(node.UniformID != null && node.UniformID > 0))
                    _checker++;

                if (node.RequestQty <= 0)
                    _checker++;


                let _uniformCodeRequestQtySum = 0;
                request.RequestItems.find((node2) => {
                    if (node.UniformID == node2.UniformID)
                        _uniformCodeRequestQtySum += Number(node2.RequestQty);
                    return null;
                });

                if (request.RequestType == "RP") {

                    if (node.NeedEvidenceList.indexOf(node.ReplaceReason) >= 0 && (!request.Attachments || request.Attachments.length === 0)) {
                        _checker++;
                        this.setState({ needEvidence: true });
                    }

                    if (_uniformCodeRequestQtySum > (node.MaxReplacementCount - node.CurrentReplacementCount))
                        _checker++;

                    if (_uniformCodeRequestQtySum > node.ReplaceableQty)
                        _checker++;
                }
                // if (node.)
                if (node.IsManItem == "Y" && node.ExpiryDate == null) {
                    _checker++;
                }
                let now = new Date().toISOString().slice(0, 7);

                if (node.IsManItem == "Y" && node.ExpiryDate < now) {
                    _checker++;
                }
                return _checker;
            });

            if (_checker > 0)
                _canSave = false;

        }
        this.setState({ allowSave: _canSave }, () => {
            if (!_canSave && this.state.IsMobileView) {

                if (document.getElementById("divAlert")) {
                    document.querySelector("#divAlert").scrollIntoView();
                    $("#divAlert").focus();
                }
            }
            this.forceUpdate();
        });
    }

    handleERNKeyPress(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleSearchClick(e);
        }
    }

    handleErnChange(e) {
        this.setState({ ern: e.target.value });
    }

    handleSearchClick(e) {
        this.setState({ searchStaffResult: '' });
        const url = this.props.apiprefix + 'pubreqgetstaff?ern=' + this.state.ern;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "GET"
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] searchErn - result");
            if (this.props.debug) console.log(result)
            this.setState({ staff: result })
            this.setState({ toApplication: false });
            if (!result.StaffID) {
                this.setState({ searchStaffResult: 'Staff not found...' });
                return;
            }
            document.querySelector("#application-card")?.scrollIntoView();
            $("#application-card").focus();
        });
    }

    handleStartOverClick(e) {
        window.location = "login";
    }

    handleRequestOtpClick(e) {
        this.setState({ requestOTPResult: '  ' });
        const url = this.props.apiprefix + 'pubreqgetotp?ern=' + this.state.ern;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "GET"
        }).then((response) => {
            return response.text()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] searchErn - result");
            if (this.props.debug) console.log(result)
            this.setState({ requestOTPResult: 'PIN was sent.  Please check your email \n認證碼已傳送到您的電郵帳戶' });
        });
    }

    handleOTPKeyPress(e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.handleEnterOtpClick(e);
        }
    }

    handleOtpChange(e) {
        this.setState({ otp: e.target.value });
    }

    handleContinueClick(e) {
        this.setState({ otp: '', inputOTPResult: '' });
    }

    handleEnterOtpClick(e) {
        this.setState({ request: {} });
        this.setState({ statusBusy: true })
        this.setState({ inputOTPResult: 'Checking...' })
        //const otp = this.state.otp;
        this.setState({ searchStaffResult: '' });
        const url = this.props.apiprefix + 'pubreqgetrequest?ern=' + this.state.ern + '&otp=' + this.state.otp;

        this.setState({ UploadAlert: "Choose File" });

        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "GET",
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log("[Application] handleOtpChanges - result");
            if (this.props.debug) console.log(result)
            this.setState({ statusBusy: false })
            if ((!result.RequestHdrID) || (result.RequestHdrID === 0)) {
                this.setState({ inputOTPResult: 'Your PIN is incorrect!  Please enter the valid PIN again. ' })
            } else {
                $('#collapseTwo').collapse("hide");
                this.setState({ inputOTPResult: '' })

                this.loadReplacementReason();
                this.setState({ request: result });

                this.loadReplacementItems();
                this.loadSpecialItems();

                let request = this.state.request;
                request.RequestType = "RP"
                request.RequestItems = [];

                this.setState(request, () => {
                    this.validateSave();
                });

            }
        });
    }

    handleRequestTypeChange(e) {
        let request = this.state.request;
        this.existManItm = 0;
        request.RequestType = e.target.value;
        request.RequestItems = [];
        this.setState(request, () => {
            this.validateSave();
        });


    }

    handleRequestSubcodeChange(e) {
        const name = this.state.IsMobileView ? e.target.parentNode.getAttribute('data-value') : e.target.name;
        let request = this.state.request;
        let requestItems = request.RequestItems;
        Object.keys(requestItems).map((m) => {
            if (requestItems[m].Seq == name) {
                if (requestItems[m].SubCodeID == e.target.value && this.state.IsMobileView) {
                    requestItems[m].SubCodeID = 0;
                } else {
                    requestItems[m].SubCodeID = e.target.value;
                }
                request.RequestItems = requestItems;
                this.setState(request, () => {
                    this.validateSave()
                });
            }
        })
    }

    handleReplaceReasonChange(e) {
        const name = this.state.IsMobileView ? e.target.parentNode.getAttribute('data-value') : e.target.name;
        let request = this.state.request;
        let requestItems = request.RequestItems;
        Object.keys(requestItems).map((m) => {
            if (requestItems[m].Seq == name) {
                requestItems[m].ReplaceReason = e.target.value;
                request.RequestItems = requestItems;
                this.setState(request, () => {
                    this.validateSave();
                });
            }
        })
    }


    handleChangeExpiryDate = (e, m) => {
        m.ExpiryDate = e.target.value == "" ? null : e.target.value;
        this.validateSave();
        this.forceUpdate();
    }

    handleRequestQtyChange(e) {
        if (e.target.value <= 0) {
            e.target.value = 1;
        }

        const name = e.target.name;
        let request = this.state.request;
        let requestItems = request.RequestItems;

        Object.keys(requestItems).map((m) => {
            if (requestItems[m].Seq == name) {
                requestItems[m].RequestQty = e.target.value;
                request.RequestItems = requestItems;
                this.setState(request, () => {
                    this.validateSave();
                });
            }
        })
    }

    handleReplaceItemAddClick(e) {
        this.existManItm = 0;
        $('#replaceRequestTable').focus();
        const name = e.target.name;
        const replaceItems = this.state.replaceItems;
        replaceItems.map((m) => {
            if (m.Seq == name) {
                let request = this.state.request;
                let requestItems = request.RequestItems;
                const newItem = new Object;
                newItem.ReqDetilsID = 0;
                //newItem.Seq = requestItems.length + 1;
                newItem.Seq = requestItems.length == 0 ? 1 : (Math.max.apply(Math, requestItems.map((m) => { return m.Seq; }))) + 1;

                newItem.UniformID = m.UniformID;
                newItem.UniformCode = m.UniformCode;
                newItem.UniformDesc = m.UniformDesc;
                newItem.UniformDescZh = m.UniformDescZh;
                newItem.UnitDesc = m.UnitDesc;
                newItem.UnitDescZh = m.UnitDescZh;
                newItem.RequestQty = 1;
                newItem.SubCodeOptions = m.SubCodeOptions;
                console.log(m);
                if (m.IsManItem == "Y") {
                    this.existManItm++;
                    var today = new Date();
                    console.log(this.existManItm);
                    newItem.ExpiryDate = new Date(today.setMonth(today.getMonth() + 8)).toISOString().slice(0, 7);
                }
                else
                    newItem.ExpiryDate = null;

                if (m.SubCodeOptions.find((n) => n.SubCodeID == m.SubCodeID)) {
                    newItem.SubCodeID = m.SubCodeID;
                }
                else {
                    newItem.SubCodeID = (Object.keys(m.SubCodeOptions).length > 1) ? 0 : m.SubCodeOptions[0].SubCodeID;
                }

                newItem.ReplaceableQty = m.ReplaceableQty;
                newItem.MaxReplacementCount = m.MaxReplacementCount;
                newItem.CurrentReplacementCount = m.CurrentReplacementCount;
                newItem.ReplaceReasonOptions = this.state.replaceReason;
                newItem.ReplaceReason = Object.keys(newItem.ReplaceReasonOptions)[0];
                newItem.NeedEvidenceList = m.NeedEvidenceList;
                newItem.ImageList = m.ImageList;
                newItem.IsManItem = m.IsManItem;
                requestItems.push(newItem);
                this.setState({ request }, () => {
                    this.validateSave();
                    this.forceUpdate();
                    if (this.props.debug) console.log(requestItems);
                });
            }


        });
        this.forceUpdate();
    }

    handleSpecialItemAddClick(e) {
        const name = e.target.name;
        const specialItems = this.state.specialItems;
        specialItems.map((m) => {
            if (m.Seq == name) {
                let request = this.state.request;
                let requestItems = request.RequestItems;
                const newItem = new Object;
                newItem.ReqDetilsID = 0;
                //newItem.Seq = requestItems.length + 1;
                newItem.Seq = requestItems.length == 0 ? 1 : (Math.max.apply(Math, requestItems.map((m) => { return m.Seq; }))) + 1;

                newItem.UniformID = m.UniformID;
                newItem.UniformCode = m.UniformCode;
                newItem.UniformDesc = m.UniformDesc;
                newItem.UniformDescZh = m.UniformDescZh;
                newItem.SubCodeID = m.SubCodeOptions.length > 1 ? m.SubCodeID : m.SubCodeOptions[0].SubCodeID;
                newItem.RequestQty = 1;
                if (m.IsManItem == "Y") {
                    this.existManItm++;
                    var today = new Date();
                    newItem.ExpiryDate = new Date(today.setMonth(today.getMonth() + 8)).toISOString().slice(0, 7);
                }
                else
                    newItem.ExpiryDate = null;
                newItem.SubCodeOptions = m.SubCodeOptions;
                newItem.ImageList = m.ImageList;
                newItem.IsManItem = m.IsManItem;
                requestItems.push(newItem);
                this.setState({ request }, () => {

                    this.validateSave();
                    this.forceUpdate();
                });
            }
        });
        this.forceUpdate();

    }

    handleUniformRemoveClick(e) {
        let request = this.state.request;
        let requestItems = request.RequestItems;
        let row = 0;
        this.existManItm = 0;
        requestItems.map((m) => {
            if (m.Seq == e.target.name) {
                requestItems.splice(row, 1);
            }
            row++;
        });

        let count = 0;
        requestItems.forEach((m) => {
            if (this.props.debug) console.log(m);
            if (m.IsManItem === "Y")
                this.existManItm++;
            m.Seq = ++count;
        });

        this.setState(request, () => {
            if (requestItems.length <= 0 && document.getElementById("application-card")) {
                document.querySelector("#application-card").scrollIntoView();
                $("#application-card").focus();
            }

            this.validateSave();
        });
    }

    handleFileUploadChange(e) {
        document.body.style.cursor = 'wait';
        this.forceUpdate();

        let validFormat = Object.assign([], this.state.Source);

        if (e.target.files.length <= 0) {
            this.setState({ UploadAlert: <div className="text-danger font-weight-bold">Invalid Input</div> });
            setTimeout(
                () => {
                    this.setState({ UploadAlert: "Choose File" });
                    this.forceUpdate();
                },
                5000
            );
            document.body.style.cursor = 'default';

            return;
        }

        var fileName = e.target.value;
        fileName = fileName.toLowerCase().substring(fileName.lastIndexOf('.'));
        if (validFormat.indexOf(fileName) < 0) {
            this.setState({ UploadAlert: <div className="text-danger font-weight-bold">Invalid Format (valid: {validFormat.toString()})</div> });
            setTimeout(
                () => {
                    this.setState({ UploadAlert: "Choose File" });
                    this.forceUpdate();
                },
                5000
            );
            document.body.style.cursor = 'default';

            return;
        }
        else if (e.target.files[0] != null && e.target.files[0].size > ((this.state.SizeLimitInMB * 1024) * 1024)) {
            this.setState({ UploadAlert: <div className="text-danger font-weight-bold">Error: file size exceeds the limit or other error(s)</div> });
            setTimeout(
                () => {
                    this.setState({ UploadAlert: "Choose File" });
                    this.forceUpdate();
                },
                5000
            );
            document.body.style.cursor = 'default';

            return;
        }

        let formData = new FormData();
        formData.append('file', e.target.files[0])
        const url = this.props.apiprefix + 'pubreqaddattachment?ern=' + this.state.ern + '&otp=' + this.state.otp;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "POST",
            body: formData,
            headers: {
                //"Content-Type": "multipart/form-data",
                
            }
        }).then((response) => {
            if (!response.ok) {
                this.setState({ UploadAlert: <div className="text-danger font-weight-bold">Error: Unknown Error</div> });
                this.forceUpdate();
                $("#customFile").val('');
                document.body.style.cursor = 'default';
                return;
            }
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log(result)

            if (result == null)
                return;

            let request = this.state.request;
            request.Attachments = result;
            this.setState(request, () => {
                this.validateSave();
                this.setState({ UploadAlert: <div className="text-success font-weight-bold">Success</div> });
                $("#customFile").val('');
                document.body.style.cursor = 'default';
                setTimeout(
                    () => {
                        this.setState({ UploadAlert: "Choose File" });
                        this.forceUpdate();
                    },
                    5000
                );
            });
        });
    }

    handleDeleteAttachmentClick(e) {
        document.body.style.cursor = 'wait';
        const url = this.props.apiprefix + 'pubreqdelattachment?ern=' + this.state.ern + '&otp=' + this.state.otp + '&imageid=' + e.target.name;
        uisFetch(this.props.accessToken,url, {
            //mode: 'no-cors',
            method: "GET",
            headers: {
                //"Content-Type": "multipart/form-data",
                
            }
        }).then((response) => {
            return response.json()
        }).then((result) => {
            if (this.props.debug) console.log(result)
            let request = this.state.request;
            request.Attachments = result;
            document.body.style.cursor = 'default'
            this.setState(request, () => {
                this.validateSave();
            });
        });
    }

    handleSubmitClick(e) {
        e.preventDefault();

        const request = this.state.request;
        // const request = {
        // ...this.state.request,
        // RequestDate: this.state.request.RequestDate
        //     ? this.state.request.RequestDate.replace(' ', 'T')
        //     : null
        // };
        request.Status = "N";
        if (this.props.debug) console.log('SAVE');
        if (this.props.debug) console.log(request);
        if (this.props.debug) console.log(JSON.stringify(request));

        const url = this.props.apiprefix + 'pubreqsaverequest?ern=' + this.state.ern + '&otp=' + this.state.otp;
        uisFetch(this.props.accessToken,url,
            {
                method: "POST",
                headers: {
                    "Content-type": "application/json; charset=utf-8"
                }, credentials: "same-origin"
                , body: JSON.stringify(request)
            }).then((response) => {
                return response.json()
            }).then((result) => {

                if (this.props.debug) console.log(result);

                this.setState({ request: result });

                if (request.RequestItems != null && request.RequestItems.length > 0) {
                    this.setState({ submitResult: 'Thank you for submission' });
                    setTimeout(
                        function () {
                            window.location.href = process.env.PUBLIC_URL || "/";
                        },
                        3000
                    );
                }
                else {
                    this.setState({ submitResult: 'Error' });
                }
            })
    }

    PassParmToModel(unifName, uniformID, imgIds) {
        this.setState({ modelTitle: unifName });
        this.setState({ modelUniformID: uniformID });
        this.setState({ modelImgIds: imgIds });
    }

    renderItemImgModal() {
        return (
            <div className="modal fade" id='itemImgModal' role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.modelTitle}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-body-autoHeight">
                            {(() => {
                                if (this.state.modelImgIds != null && this.state.modelImgIds.length > 0) {
                                    return (
                                        <div id="_carouselIndId" className="carousel slide" data-ride="carousel" data-interval="false">
                                            <div className="carousel-inner">
                                                {
                                                    this.state.modelImgIds.map((m, index) => {
                                                        const key = `${this.state.modelUniformID}_${m.ImgId}`;
                                                        const blobUrl = this.state.uniformdownloadattachement[key];
                                                        if (!blobUrl) {
                                                            this.loadUniformdownloadattachement(this.state.modelUniformID, m.ImgId);
                                                        }
                                                        return <div key={"modelImg" + index + Math.floor(Math.random() * 1000) + Math.floor(Math.random() * 1000)} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                            <div className="card">
                                                                <div className="col-12 justify-content-center align-self-center text-center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} >
                                                                    {m.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0 ? (
                                                                        blobUrl ? (
                                                                            <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={stripSurroundingQuotes(m.ImgFileName)}>
                                                                                <img className="img-thumbnail text-center" src={blobUrl} alt="Card image cap"/>
                                                                            </a>
                                                                        ) : (
                                                                            <div>Loading image...</div>
                                                                        )
                                                                    ) : (
                                                                        blobUrl ? (
                                                                            <a className="card-img-top image1 text-center" href={blobUrl} alt="Card image cap" download={stripSurroundingQuotes(m.ImgFileName)}
                                                                            target="_blank" rel="noopener noreferrer">Click to preview {m.ImgFileName} </a>
                                                                        ) : (
                                                                            <div>Loading PDF...</div>
                                                                        )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </div>
                                            {this.state.modelImgIds != null && this.state.modelImgIds.length > 1 &&
                                                <a className="carousel-control-prev" href="#_carouselIndId" role="button" data-slide="prev">
                                                    <span className="carousel-control-prev-icon carousel-control-shape" aria-hidden="true"></span>
                                                    <span className="sr-only">Previous</span>
                                                </a>
                                            }
                                            {this.state.modelImgIds != null && this.state.modelImgIds.length > 1 &&
                                                <a className="carousel-control-next" href="#_carouselIndId" role="button" data-slide="next">
                                                    <span className="carousel-control-next-icon carousel-control-shape" aria-hidden="true"></span>
                                                    <span className="sr-only">Next</span>
                                                </a>
                                            }
                                        </div>
                                    )
                                } else {
                                    return (<img src={`${process.env.PUBLIC_URL}/Images/no-image.png`} width='100%' className="img-thumbnail w-100" />)
                                }
                            })()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    async loadMeasurementImage(uniformId, imgId) {
        const key = `${uniformId}_${imgId}`;
        const now = Date.now();
        
        if (this.state.measurementImages[key]) {
            return;
        }
        
        if (this.state.loadingImages[key]) {
            return;
        }
        
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = `${this.props.apiprefix}getimage?unm=${uniformId}&uni=${imgId}`;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState(prevState => ({
                    measurementImages: {
                        ...prevState.measurementImages,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load image error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }
    
    async loadUniformdownloadattachement(modelUniformID,documentId) {
        const key = `${modelUniformID}_${documentId}`;
        const now = Date.now();
        
        if (this.state.uniformdownloadattachement[key]) {
            return;
        }
        
        if (this.state.loadingImages[key]) {
            return;
        }
        
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = this.props.apiprefix + 'uniformdownloadattachement?unm=' + modelUniformID+ '&uni=' +  documentId;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState((prevState) => ({
                    uniformdownloadattachement: {
                        ...prevState.uniformdownloadattachement,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load uniform attachment error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }

    async loadViewattachment(attachmentId) {
        const key = attachmentId.toString();
        const now = Date.now();
        
        if (this.state.viewattachment[key]) {
            return;
        }
        
        if (this.state.loadingImages[key]) {
            return;
        }
        
        const lastLoadTime = this.state.imageLoadTimestamps[key];
        if (lastLoadTime && (now - lastLoadTime) < this.REQUEST_COOLDOWN) {
            return;
        }
        
        this.setState(prevState => ({
            loadingImages: {
                ...prevState.loadingImages,
                [key]: true
            },
            imageLoadTimestamps: {
                ...prevState.imageLoadTimestamps,
                [key]: now
            }
        }));
        
        try {
            const url = this.props.apiprefix + 'viewattachment?imageid=' + attachmentId;
            const base64Data = await fetchAndConvertToBase64(url, this.props.accessToken);
            
            if (base64Data) {
                this.setState((prevState) => ({
                    viewattachment: {
                        ...prevState.viewattachment,
                        [key]: base64Data,
                    },
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            } else {
                this.setState(prevState => ({
                    loadingImages: {
                        ...prevState.loadingImages,
                        [key]: false
                    }
                }));
            }
        } catch (error) {
            console.error(`load view attachment error ${key}:`, error);
            this.setState(prevState => ({
                loadingImages: {
                    ...prevState.loadingImages,
                    [key]: false
                }
            }));
        }
    }
    render() {
        return (
            <>
                <div className="container bg-secondary " style={{ maxHeight: '100vh', position: 'absolute', top: '0%', bottom: '0%' }}>
                    <div className="gap-line" style={this.state.IsMobileView ? { display: 'none' } : {}} />
                    <div className={"col-12 " + (this.state.IsMobileView ? "card-body-wider" : "")} >
                        <br style={this.state.IsMobileView ? { display: 'none' } : {}} />
                        <div id="ApplicationForm" className="card border-light bg-light" style={{ maxHeight: this.state.IsMobileView ? '90vh' : '100vh' }} >

                            <div id="application-card-header" className="card-header text-white">
                                <div className="d-flex">
                                    <div className="mr-auto justify-content-center align-self-center">
                                        <label className={(this.state.IsMobileView ? 'h4 ' : 'h2')}  >Request 申請</label>
                                    </div>
                                    <div>
                                    <img className="img-fluid FormCompanyLogo" src={`${process.env.PUBLIC_URL}/Images/Form_CompanyLogo_white.png`} />
                                    </div>
                                </div>
                            </div>
                            <div className={"card-body " + (this.state.IsMobileView ? "p-0" : "")} style={{ overflow: 'hidden scroll' }}>
                                {/*<form>*/}
                                <div className="form-group">
                                    <div className="accordion" id="accordionExample">
                                        <div className="card">
                                            {this.renderERN()}
                                        </div>
                                        <div className="card">
                                            {this.renderOtp()}
                                        </div>
                                        {this.renderRequest()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal fade"
                    id="logoutModal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="exitModalLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exitModalLabel">Warning</h5>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body"> {config.NO_AUTH_MSG } </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={() => {
                                        window.location.href = process.env.PUBLIC_URL || "/";
                                    }}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        );
    }

    renderERN() {
        let domStaffInfo;
        const staff = this.state.staff;
        let domRequestOTP;
        if (this.state.requestOTPResult === '') {
            domRequestOTP = (
                <button type="button" className="btn btn-warning border-secondary w-100" onClick={this.handleRequestOtpClick.bind(this)}>Request PIN 申請</button>
            )
        } else {
            domRequestOTP = (
                <span className="text-success w-100"><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small font-weight-bold" : ""}>{this.state.requestOTPResult}</label></span>
            )
        }

        let domCurrentHoldItems;
        if (this.state.staff.onHoldItemList) {
            const onHoldItems = this.state.staff.onHoldItemList;
            let row = 0;
            let _onHoldItems1 = [];

            (onHoldItems).forEach((m) => {
                let _position = _onHoldItems1.findIndex((e) => e.UniformDesc == m.UniformDesc);
                if (_position >= 0) {
                    let _positionSub = _onHoldItems1[_position].SubCodeInfoList.findIndex((e) => e.SubCode == m.SubCode);
                    if (_positionSub >= 0) {
                        _onHoldItems1[_position].SubCodeInfoList[_positionSub].QtyInfoList.push({ OnHoldQty: m.OnHoldQty, StatusDesc: m.StatusDesc, StatusDescZh: m.StatusDescZh, CollectionDateList: m.CollectionDateList });
                    }
                    else {
                        let _qtyInfoList = [];
                        _qtyInfoList.push({ OnHoldQty: m.OnHoldQty, StatusDesc: m.StatusDesc, StatusDescZh: m.StatusDescZh });
                        _onHoldItems1[_position].SubCodeInfoList.push({ SubCode: m.SubCode, SubCodeDesc: m.SubCodeDesc, SubCodeDescZh: m.SubCodeDescZh, QtyInfoList: _qtyInfoList, CollectionDateList: m.CollectionDateList });
                    }
                }
                else {
                    let _node = new Object();
                    _node.UniformDesc = m.UniformDesc;
                    _node.UniformDescZh = m.UniformDescZh;
                    let _qtyInfoList = [];
                    _qtyInfoList.push({ OnHoldQty: m.OnHoldQty, StatusDesc: m.StatusDesc, StatusDescZh: m.StatusDescZh });
                    _node.SubCodeInfoList = [];
                    _node.SubCodeInfoList.push({ SubCode: m.SubCode, SubCodeDesc: m.SubCodeDesc, SubCodeDescZh: m.SubCodeDescZh, QtyInfoList: _qtyInfoList, CollectionDateList: m.CollectionDateList });
                    _onHoldItems1.push(_node);
                }
            });

            let _onHoldItems2 = [];
            (_onHoldItems1).forEach((m) => {
                let _node = new Object();
                _node.UniformDesc = m.UniformDesc;
                _node.UniformDescZh = m.UniformDescZh;
                _node.Info = m.SubCodeInfoList.map((n) => {
                    let _qtyinfoList = n.QtyInfoList.map((i) => {
                        return (
                            <span><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "w-100 text-right" : ""}>{i.OnHoldQty} ( {i.StatusDesc} {i.StatusDesc != i.StatusDescZh ? i.StatusDescZh : ""} )&nbsp;&nbsp;</label></span>
                        )
                    })
                        ;
                    return (
                        <div>
                            <span>Size 尺碼 : </span>
                            <b><i><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "w-100 text-right" : ""}>{n.SubCode} - {n.SubCodeDesc} {n.SubCodeDesc != n.SubCodeDescZh ? n.SubCodeDescZh : ""}</label></i></b>
                            <br />
                            <span>Qty 數量 : </span>
                            {(!this.state.IsTabletView && this.state.IsMobileView) ? <br /> : ""}
                            <b>{_qtyinfoList}</b>
                            <br />
                            <span>Collection Date 領取日期 : </span>
                            {(!this.state.IsTabletView && this.state.IsMobileView) ? <br /> : ""}
                            <b><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "w-100 text-right" : ""}>{n.CollectionDateList}</label></b>
                            {/* {(!this.state.IsTabletView && this.state.IsMobileView) ? "" : <br />} */}
                            {m.SubCodeInfoList != null && m.SubCodeInfoList.length > 1 && m.SubCodeInfoList[m.SubCodeInfoList.length - 1] != n ? <div className="border-bottom"></div> : ''}
                            {/* {(!this.state.IsTabletView && this.state.IsMobileView) ? "" : <br />} */}
                        </div>
                    )
                });
                _onHoldItems2.push(_node);

            });

            domCurrentHoldItems = _onHoldItems2.map((m) => {
                row++;
                return (
                    <tr key={row}>
                        <td>
                            <b><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "w-100 text-center" : ""}><span className="border-bottom border-dark">{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</span></label></b>
                            <br />
                            {m.Info}

                        </td>
                    </tr>
                );
            });
        }




        if ((staff) && (staff.StaffID)) {
            domStaffInfo = (
                <div className="row">
                    <br />


                    {/* <div className={this.state.IsMobileView ? "col-12" : "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"}> */}
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                        <div className="card">
                            <div className="card-header font-weight-bold " style={(!this.state.IsTabletView && this.state.IsMobileView) ? { padding: "1px 1px 0px 20px" } : {}} ><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small font-weight-bold" : ""}> Staff Information 員工資料</label></div>
                            <div className="card-body">
                                <div className="form-row">
                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <label className={!this.state.IsTabletView && this.state.IsMobileView ? "small" : ""}>Staff Name  {this.state.IsMobileView ? <br /> : ""}姓名: </label>
                                    </div>
                                    <div className="col-6 col-sm-9 col-md-9 col-lg-9 col-xl-9 font-weight-bold ">
                                        <label className={!this.state.IsTabletView && this.state.IsMobileView ? "small" : ""}>{staff.LastName} {staff.FirstName} {staff.PrefName != null ? ', ' + staff.PrefName : ''}</label>
                                    </div>
                                </div>

                                <div className="form-row mt-3">
                                    <div className="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                        <label className={!this.state.IsTabletView && this.state.IsMobileView ? "small" : ""}>Department  {this.state.IsMobileView ? <br /> : ""}部門: </label>
                                    </div>
                                    <div className="col-6 col-sm-9 col-md-9 col-lg-9 col-xl-9 font-weight-bold ">
                                        <label className={!this.state.IsTabletView && this.state.IsMobileView ? "small" : ""}>{staff.Department}</label>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <br />
                    </div>


                    {!this.state.toApplication &&
                        // <div className={this.state.IsMobileView ? "col-12" : "col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"}>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <div className="card">
                                <div className="card-header font-weight-bold" style={(!this.state.IsTabletView && this.state.IsMobileView) ? { padding: "1px 1px 0px 20px" } : {}}><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small font-weight-bold" : ""}> Current Hold Uniform 現持有制服</label></div>
                                <div className="card-body">
                                    <div className="form-row font-weight-bold">

                                        <div id="currentHoldTable" className={(!this.state.IsTabletView && this.state.IsMobileView) ? "table-responsive" : "tableFixHead table-responsive"}>
                                            <table className="table table-striped dt-responsive w-100 small" >
                                                <tbody>
                                                    {domCurrentHoldItems}
                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }

                    {this.state.toApplication &&
                        <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                            <div className="card">
                                <div className="card-header font-weight-bold" style={(!this.state.IsTabletView && this.state.IsMobileView) ? { padding: "1px 1px 0px 20px" } : {}}><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small" : ""}>1. Get an PIN (Skip if already have one) <br /> 申請認證碼 (已申請可跳過)</label></div>
                                <div className="card-body">
                                    <div className="form-row font-weight-bold">
                                        {(this.state.staff.StaffID > 0) && domRequestOTP}
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="card">
                                <div className="card-header font-weight-bold" style={(!this.state.IsTabletView && this.state.IsMobileView) ? { padding: "1px 1px 0px 20px" } : {}}><label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small" : ""}>2. Continue with your PIN 下一步</label></div>
                                <div className="card-body">
                                    <div className="form-row font-weight-bold">
                                        <a id="btnCollapseOneContinue" className="btn btn-info border-secondary w-100" data-toggle="collapse" href="#collapseTwo" role="button" aria-expanded="false" aria-controls="collapseTwo" onClick={this.handleContinueClick.bind(this)} >Next 下一步</a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    }
                </div>
            );


        }

        const handleToApplicationClick = (e) => {
            e.preventDefault();
            this.setState({ toApplication: this.state.toApplication ? false : true });

            if (this.state.otp != null && this.state.otp.length > 0)
                setTimeout(
                    () => {
                        $('#collapseTwo').collapse("show");
                        this.handleEnterOtpClick();
                    },
                    5
                );
        }

        return (
            <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample" style={this.state.IsMobileView ? { height: '80vh' } : {}}>
                <div className={"card-body " + (this.state.IsMobileView ? '' : '')} style={this.state.IsMobileView ? { overflowY: 'scroll', height: '85%' } : { height: '80%' }}>
                    <div className="d-flex">
                        <div className="mx-auto" style={{ width: '100%' }}>

                            {!((staff) && (staff.StaffID)) &&
                                <div className="row">
                                    <p className={"w-100 text-center " + (this.state.IsMobileView ? 'h5' : 'h2')}> Please Confirm Staff Information <br /> 請確認員工資料</p>
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />

                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                        {/* <div className="form-row"> */}
                                        <p className={"largeText " + (this.state.IsMobileView ? " " : " text-right")} >  Staff ID  員工編號: </p>
                                        {/* </div> */}
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                        <div className="form-row">
                                            <input
                                                type="text"
                                                className="form-control bg-light text-muted"
                                                placeholder="Enter Staff ID 輸入員工編號"
                                                style={this.state.IsMobileView ? { maxWidth: '100%' } : { maxWidth: '50%' }}
                                                value={this.state.ern}
                                                readOnly
                                                disabled
                                            />
                                            <span>&#xA0;</span>
                                            {(this.state.staff.StaffID) ?
                                                <button type="button" className="btn btn-secondary" onClick={this.handleStartOverClick.bind(this)}>Start Over 重新開始</button>
                                                :
                                                <button type="button" className="btn btn-secondary " style={this.state.IsMobileView ? { marginTop: '10px' } : {}} onClick={this.handleSearchClick.bind(this)}>Search 搜尋</button>
                                            }
                                            <span>&#xA0;</span>
                                            <span className='text-danger largeText' style={this.state.IsMobileView ? { padding: '13px 0px 0px 10px' } : { marginLeft: '2px' }}>{this.state.searchStaffResult}</span>
                                        </div>
                                    </div>
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                    <div className="gap-line col-12" />
                                </div>

                            }

                            {domStaffInfo}
                        </div>
                    </div>
                    <div className="gap-line col-12" />
                </div>
                {(staff) && (staff.StaffID) &&
                    <div className="card-footer" style={{ overflowY: 'scroll', height: '15%' }}>
                        <button type="button" className="btn btn-secondary center-block w-100" width='20px' onClick={handleToApplicationClick.bind(this)}>{this.state.toApplication ? "Enquiry Current Hold Uniform 查詢現持有制服" : "Request 申請"}</button>
                    </div>
                }
            </div>
        );
    }


    renderOtp() {
        const request = this.state.request;
        if ((request.RequestHdrID) && (request.RequestHdrID !== 0))
            return (<div></div>);

        return (
            <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample" style={{ height: '85vh' }}>
                <div className={"card-body " + (this.state.IsMobileView ? "" : "card-body-top-space")} style={this.state.IsMobileView ? { overflowY: 'scroll', height: '90%' } : { height: '80%' }}>

                    <div className="d-flex">
                        <div className="mx-auto">

                            <div className="form-row">
                                <div className="alert alert-warning  fade show largeText" role="alert">
                                    <label className={(!this.state.IsTabletView && this.state.IsMobileView) ? "small" : ""}>
                                        An PIN has been sent to your email account, Please type-in the PIN to continue
                                        <br />
                                        認證碼已傳送到您的電郵帳戶。請根據電郵中的密碼輸入在以下空格內
                                    </label>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-form-label largeText">
                                    <label>PIN  認證碼: </label>
                                </div>
                                <input type="text" className="form-control" placeholder="Enter PIN here 輸入認證碼" required style={{ "maxWidth": '100%', "whiteSpace": 'pre-line', "position": 'relative' }} value={this.state.otp} onChange={this.handleOtpChange.bind(this)} onKeyPress={this.handleOTPKeyPress.bind(this)} />
                            </div>
                            <br />
                            <div className="form-row">

                                <div className="d-flex">
                                    <div className="mx-auto">

                                        <span className='text-danger mediumText'>{this.state.inputOTPResult}</span>

                                    </div>
                                </div>
                            </div>
                            <div className="gap-line col-12" />

                        </div>

                    </div>

                </div>
                <div className="card-footer" style={{ overflowY: 'scroll', height: '10%' }}>
                    <div className="form-row ">

                        <div className="d-flex w-100">
                            <div className="mx-auto">
                                {(!this.state.statusBusy) &&
                                    <a id="btnCollapseTwoContinue" className="btn btn-info mb-1" data-toggle="collapseXXXX" href="#" role="button" aria-expanded="false" aria-controls="collapseThree" value={this.state.otp} onClick={this.handleEnterOtpClick.bind(this)}>Next 下一步</a>
                                }
                                <span>&#xA0;</span>
                                {/* {this.state.inputOTPResult != null && this.state.inputOTPResult.length > 0 &&  */}
                                {/* <button className="btn btn-secondary mb-1" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onClick={this.handleStartOverClick.bind(this)}>Start Over 重新開始</button> */}
                                <button className="btn btn-secondary mb-1" type="button" onClick={this.handleStartOverClick.bind(this)}>Start Over 重新開始</button>
                                {/* } */}
                                <span>&#xA0;</span>
                                {/* <span className='text-danger mediumText'>{this.state.inputOTPResult}</span> */}

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }

    renderRequest() {
        let request = this.state.request;

        if ((!request.RequestHdrID) || (request.RequestHdrID === 0)) {
            return (<div></div>);
        }

        let row = 0, _accordionId, _headingId, _collapseId;
        let domRequestedItems;
        //let needEvidence = 0;

        if (request.RequestItems.length > 0) {
            domRequestedItems = request.RequestItems.map((m) => {
                //this.existManItm = false;
                if (this.props.debug) console.log(m);
                if (m.IsManItem === "Y")
                    this.existManItm++;
                if (m.ImageList && m.ImageList.length > 0) {
                    m.ImageList.forEach((m2) => {
                        const key = `${m.UniformID}_${m2.ImgId}`;
                        if (!this.state.measurementImages[key]) {
                            this.loadMeasurementImage(m.UniformID, m2.ImgId);
                        }
                    });
                }

                let subCodeOptions = m.SubCodeOptions;
                let domSubCodeOptions;
                if ((subCodeOptions) && (Object.keys(subCodeOptions).length > 0) && request.Status === 'B') {
                    if (this.state.IsMobileView == false) {
                        domSubCodeOptions = Object.keys(subCodeOptions).map((n) => {
                            return (
                                <option key={subCodeOptions[n].SubCodeID} value={subCodeOptions[n].SubCodeID}>{subCodeOptions[n].SubCode}</option>
                            );
                        });
                    }
                    else {
                        domSubCodeOptions = Object.keys(subCodeOptions).map((n) => {
                            return (
                                <button type="button" key={subCodeOptions[n].SubCodeID} value={subCodeOptions[n].SubCodeID} className={"btn btn-outline-secondary subCode-btn-options " + (subCodeOptions[n].SubCodeID == m.SubCodeID ? "active" : "")} onClick={(e) => { this.handleRequestSubcodeChange(e) }} >{subCodeOptions[n].SubCode}</button>
                                // <option key={subCodeOptions[n].SubCodeID} value={subCodeOptions[n].SubCodeID}>{subCodeOptions[n].SubCode}</option>
                            );
                        });

                    }

                }

                let domReplaceReasons;
                const replaceReason = this.state.replaceReason;
                if (Object.keys(replaceReason).length > 0) {
                    if (this.state.IsMobileView == false) {
                        domReplaceReasons = Object.keys(replaceReason).map((i) => {
                            return (
                                <option key={i} value={i}>{replaceReason[i]}</option>
                            );
                        })
                    } else {
                        domReplaceReasons = Object.keys(replaceReason).map((i) => {
                            return (
                                <button type="button" key={i} value={i} className={"btn btn-outline-secondary subCode-btn-options " + (i == m.ReplaceReason ? "active" : "")} onClick={(e) => { this.handleReplaceReasonChange(e) }} >{replaceReason[i]}</button>
                            );
                        })
                    }
                }

                let _uniformCodeRequestQtySum = 0;
                request.RequestItems.find((node) => {
                    if (m.UniformID == node.UniformID)
                        _uniformCodeRequestQtySum += Number(node.RequestQty);
                    return null;
                });

                let now = new Date().toISOString().slice(0, 7);
                let IsReqQtyMoreThanOnHold = (request.RequestType === "RP") && (_uniformCodeRequestQtySum > m.ReplaceableQty) && request.Status === 'B';
                let IsReachMax = (request.RequestType === "RP") && (_uniformCodeRequestQtySum > (m.MaxReplacementCount - m.CurrentReplacementCount)) && request.Status === 'B';
                let IsNeedEvidence = ((request.RequestType === "RP") && (m.NeedEvidenceList != null && m.NeedEvidenceList.indexOf(m.ReplaceReason) >= 0) || (request.RequestType === "S")) && (!request.Attachments || request.Attachments.length === 0) && request.Status === 'B';
                let IsManItem = ((m.IsManItem == "Y" && m.ExpiryDate == null) || (m.IsManItem == "Y" && m.ExpiryDate < now));
                if (this.state.IsMobileView == false) {
                    let _accordionId = "mobDomReqItmAccordion" + row;
                    let _headingId = "mobDomReqItmHeading" + row;
                    let _collapseId = "mobDomReqItmCollapse" + row;
                    let _carouselIndId = "mobDomReqItm_carouselInd" + row;
                    row++;
                    return (
                        <tr key={m.Seq}
                            className={"" +
                                //((request.RequestType === 'R') &&   ( m.RequestQty > m.ReplaceableQty) ? " test bg-warning text-white" : ((request.RequestType === "RP") && (m.RequestQty > (m.MaxReplacementCount - m.CurrentReplacementCount))) ? " test bg-danger text-white" : "")
                                (IsReqQtyMoreThanOnHold ? " test bg-warning text-white font-weight-bold" : IsReachMax ? " test bg-danger text-white" : IsManItem ? "test bg-info text-white font-weight-bold" : "")
                            }
                            style={IsNeedEvidence ? { backgroundColor: 'OrangeRed', fontWeight: 'bold', color: 'white' } : {}}
                        // IsManItem ? { backgroundColor: 'Blue', fontWeight: 'bold', color: 'white' } : {}}


                        >
                            {/* <td scope="col">{m.UniformCode}</td> */}
                            <td scope="col-sm" className="align-middle">{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</td>
                            <td scope="col-sm" className="align-middle">

                                {m.ImageList != null && m.ImageList.length > 0 ?
                                    <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >

                                        <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                            onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                            {
                                                m.ImageList.map((m2, index) => {
                                                    const key = m.UniformID + '_' + m2.ImgId;;
                                                    const blobUrl = this.state.measurementImages[key];
                                                    return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                        <div className="card-header" id={m2.imgId}>
                                                            <div className="col-12 justify-content-center align-self-center text-center" >
                                                                {(() => {
                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                    const blobUrl = this.state.measurementImages[key];
                                                                    if (!blobUrl) {
                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                        return <span>Loading...</span>;
                                                                    }
                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                        return (
                                                                          <img src={blobUrl}
                                                                                className="d-block w-100 img-thumbnail "
                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <a className="card-img-top image1 text-center" alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                        );
                                                                    }
                                                                })()}
                                                            </div>
                                                        </div>

                                                    </div>
                                                })
                                            }
                                        </div>
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Previous</span>
                                            </a>
                                        }
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Next</span>
                                            </a>
                                        }
                                    </div>
                                    :
                                    <div className="d-flex justify-content-center">
                                        <img name={m.Seq}
                                            src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                            width='100%' className="img-thumbnail w-100" style={{ maxHeight: "80px", maxWidth: "80px", margin: "0 auto", }}
                                        // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                        />
                                    </div>
                                }
                            </td>
                            {(request.RequestType === "RP") &&
                                <td scope="col-sm" className="align-middle">Current 現時: {m.CurrentReplacementCount} <br /> Max 最高: {m.MaxReplacementCount} </td>
                            }
                            {(request.RequestType === "RP") &&
                                <td scope="col-sm" className="align-middle">{m.ReplaceableQty} {m.UnitDesc} / {m.UnitDescZh} </td>
                            }
                            <td scope="col-sm" className="align-middle">
                                <input name={m.Seq} type="number" data-width="100%" className="form-control font-weight-bold" style={{ width: "100px" }} value={m.RequestQty} onChange={this.handleRequestQtyChange.bind(this)} />
                            </td>
                            <td scope="col-sm" className="text-nowrap align-middle">
                                <select id="select_Request_subcode" name={m.Seq} data-width="100%" className="form-control w-auto" value={m.SubCodeID} onChange={this.handleRequestSubcodeChange.bind(this)}>
                                    {(domSubCodeOptions != null && domSubCodeOptions.length > 1) &&
                                        <option value='0'>*To-Be-Measured 度身*</option>
                                    }
                                    {domSubCodeOptions}
                                </select>
                            </td>
                            {(request.RequestType === "RP") &&
                                <td scope="col-sm" className="align-middle">
                                    <select name={m.Seq} className="form-control w-auto" value={m.ReplaceReason} onChange={this.handleReplaceReasonChange.bind(this)} >
                                        {domReplaceReasons}
                                    </select>
                                </td>
                            }
                            {(m.IsManItem === "Y") &&
                                <td scope="col-sm" className="align-middle">
                                    <input name={m.Seq} className="form-control w-auto" type="month" value={m.ExpiryDate} onChange={(e) => this.handleChangeExpiryDate(e, m)} />
                                    <small className="card-text">Expiry Date = Inputted Date + 6 months</small>
                                </td>
                            }
                            {(m.IsManItem === "N" && this.existManItm > 0) &&
                                <td scope="col-sm" className="align-middle">
                                    -----
                                </td>
                            }
                            <td className="align-middle" scope="col-sm">
                                {(request.Status === 'B') &&
                                    <button name={m.Seq} className="btn btn-danger border-secondary" onClick={this.handleUniformRemoveClick.bind(this)}>
                                        <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-192-minus-sign.png`} width='20px' />
                                    </button>
                                }
                            </td>
                        </tr>
                    )
                }
                else {
                    let _accordionId = "mobDomReqItmAccordion" + row;
                    let _headingId = "mobDomReqItmHeading" + row;
                    let _collapseId = "mobDomReqItmCollapse" + row;
                    let _carouselIndId = "mobDomReqItm_carouselInd" + row;

                    row++;
                    return (
                        <div key={"mobDomReqItm" + m.Seq}>
                            <div id={_accordionId} className="card shadow rounded mt-3" key={"mobDomReqItm" + m.Seq + Math.floor(Math.random() * 1000) + Math.floor(Math.random() * 1000)} >
                                <div id={_headingId} className={"card-header cardView-header-bg-Color " + (IsReqQtyMoreThanOnHold ? " test bg-warning text-white" : IsReachMax ? " test bg-danger text-white" : "")}
                                    style={IsNeedEvidence ? { backgroundColor: 'OrangeRed', fontWeight: 'bold', color: 'white' } :
                                        IsManItem ? { backgroundColor: 'Blue', fontWeight: 'bold', color: 'white' } : {}}>
                                    <h5 className="mb-0" style={{ textAlign: 'left' }}>
                                        <a className="btn btn-link cardView-header-link w-100 text-white" data-toggle="collapse" href={'#' + _collapseId} aria-expanded="true" aria-controls={_collapseId}>
                                            <label className="card-text h5 font-weight-bold text-white">{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</label>
                                        </a>
                                    </h5>
                                </div>
                                <div id={_collapseId} className="collapse show" aria-labelledby={_headingId} data-parent={'#' + _accordionId}>
                                    <div className={"card-body cardView-body-bg-Color text-sm-left " + (IsReqQtyMoreThanOnHold ? " test bg-warning text-white" : IsReachMax ? " test bg-danger text-white" : "")}
                                        style={IsNeedEvidence ? { backgroundColor: 'OrangeRed', fontWeight: 'bold', color: 'white' } :
                                            IsManItem ? { backgroundColor: 'Blue', fontWeight: 'bold', color: 'white' } : {}}>
                                        {/* <small className={"card-subtitle mb-2 " + (IsNeedEvidence || IsReachMax || IsReqQtyMoreThanOnHold ? "" : "text-muted")}>{m.UniformCode}</small>
                                    <hr /> */}
                                        {m.ImageList != null && m.ImageList.length > 0 ?
                                            <div id={_carouselIndId} className="carousel slide " data-ride="carousel" data-interval="false"  >
                                                {/* <ol className="carousel-indicators">
                                            {
                                                m.ImgIds.map((imgId, index) => {
                                                    return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                })
                                            }
                                        </ol> */}
                                                <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                                    onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                                    {
                                                        m.ImageList.map((m2, index) => {
                                                            return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                                <div className="card-header" id={m2.imgId}>
                                                                    <div className="col-12  justify-content-center align-self-center"  >
                                                                        {(() => {
                                                                            const key = `${m.UniformID}_${m2.ImgId}`;
                                                                            const blobUrl = this.state.measurementImages[key];
                                                                            const isLoading = this.state.loadingImages[key];
                                                                            
                                                                            if (!blobUrl && !isLoading) {
                                                                                this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                            }
                                                                            
                                                                            if (isLoading || !blobUrl) {
                                                                                return <span>Loading...</span>;
                                                                            }
                                                                            
                                                                            if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                                return (
                                                                                <img src={blobUrl}
                                                                                        className="d-block w-100 img-thumbnail "
                                                                                    style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                                );
                                                                            } else {
                                                                                return (
                                                                                    <a className="card-img-top image1" alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                                );
                                                                            }
                                                                        })()}
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        })
                                                    }
                                                </div>
                                                {m.ImageList != null && m.ImageList.length > 1 &&
                                                    <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                        <span className="sr-only">Previous</span>
                                                    </a>
                                                }
                                                {m.ImageList != null && m.ImageList.length > 1 &&
                                                    <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                        <span className="sr-only">Next</span>
                                                    </a>
                                                }
                                            </div>
                                            :
                                            <div className="d-flex justify-content-center ">
                                                <img name={m.Seq}
                                                    src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                    width='100%' className="img-thumbnail w-100" style={{ maxHeight: "200px", maxWidth: "200px", margin: "0 auto", }}
                                                // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                                />
                                            </div>
                                        }
                                        <hr />


                                        {
                                            (() => {
                                                if (request.RequestType === "RP") {
                                                    return (
                                                        <div>
                                                            <hr className="d-none d-sm-block d-md-none" />
                                                            <p><small className="card-text">Replacement Count 可更換限額</small></p>
                                                            <div className="row">
                                                                {this.state.IsTabletView && <div style={{ padding: "20px" }} />}
                                                                <a className="btn btn-link cardView-header-link w-100 col-4 col-sm-3 cardView-box-bg-color"><label className={"mt-3 " + this.state.IsMobileView && !this.state.IsTabletView ? "small" : ""}><span className="font-weight-bold h4">{m.CurrentReplacementCount}</span><br /><span className={(IsNeedEvidence || IsReachMax || IsReqQtyMoreThanOnHold ? "" : "text-muted")}>Current<br />現時</span></label></a>
                                                                {this.state.IsTabletView && <div style={{ padding: "20px" }} />}
                                                                <a className="btn btn-link cardView-header-link w-100 col-4 col-sm-3  cardView-box-bg-color"><label className={"mt-3 " + this.state.IsMobileView && !this.state.IsTabletView ? "small" : ""}><span className="font-weight-bold h4">{m.MaxReplacementCount}</span><br /><span className={(IsNeedEvidence || IsReachMax || IsReqQtyMoreThanOnHold ? "" : "text-muted")}>Max<br />最高</span></label></a>
                                                                {this.state.IsTabletView && <div style={{ padding: "20px" }} />}
                                                                <a className="btn btn-link cardView-header-link w-100 col-4 col-sm-3  cardView-box-bg-color"><label className={"mt-3 " + this.state.IsMobileView && !this.state.IsTabletView ? "small" : ""}><span className="font-weight-bold h4">{m.ReplaceableQty}</span><label className="small"> &nbsp; {m.UnitDesc} / {m.UnitDescZh}</label><br /><span className={(IsNeedEvidence || IsReachMax || IsReqQtyMoreThanOnHold ? "" : "text-muted")}>Replaceable Qty<br />可更換數量</span></label></a>
                                                                {this.state.IsTabletView && <div style={{ padding: "20px" }} />}


                                                            </div>
                                                            <hr />
                                                        </div>
                                                    )
                                                }
                                            })()}
                                        <div>
                                            <small className="card-text">Qty 數量</small>
                                            <input name={m.Seq} type="number" className="form-control w-100" pattern="\d*" defaultValue={m.RequestQty} min="0" onBlur={this.handleRequestQtyChange.bind(this)} />

                                        </div>
                                        <hr />
                                        <div>
                                            <small className="card-text">Size 尺碼</small>
                                            <div className="form-group" style={{ marginTop: '5px' }} data-value={m.Seq}>
                                                {(m.SubCodeOptions != null && m.SubCodeOptions.length > 1) &&
                                                    <button type="button" value='0' className={"btn btn-outline-secondary subCode-btn-options " + (m.SubCodeID == 0 || m.SubCodeID == null ? "active" : "")} onClick={(e) => { this.handleRequestSubcodeChange(e) }} > *To-Be-Measured 度身*</button>
                                                }


                                                {domSubCodeOptions}
                                            </div>
                                        </div>
                                        <hr />
                                        {
                                            (() => {
                                                if (request.RequestType === "RP") {
                                                    return (<div>
                                                        <small className="card-text">Reason 原因</small>
                                                        <div className="form-group" style={{ marginTop: '5px' }} data-value={m.Seq}>
                                                            {domReplaceReasons}
                                                        </div>
                                                        <hr />
                                                    </div>
                                                    )
                                                }
                                            })()
                                        }
                                        {
                                            (() => {
                                                if (m.IsManItem === "Y") {
                                                    return (<div>
                                                        <small className="card-text">Expected Delivery Date 預產期</small>
                                                        <div className="form-group" style={{ marginTop: '5px' }} data-value={m.Seq}>
                                                            <input name={m.Seq} className="form-control w-auto" type="month"
                                                                value={m.ExpiryDate} onChange={(e) => this.handleChangeExpiryDate(e, m)} />
                                                            <small className="card-text">Expiry Date = Inputted Date + 6 months</small>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                    )
                                                }

                                            })()
                                        }
                                        <div className="row">
                                            {/* <a data-toggle="modal" data-target="#itemImgModal" className="btn btn-secondary center-block p-3 w-100 col-sm-4 col-xs-12"
                                                onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImgIds)}>
                                                <div className="font-weight-bold text-white" >
                                                    <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture-w.png`} className="mt-2" className="mr-1" />
                                                    Image 圖片
                                                </div>
                                            </a> */}
                                            <div className="col-4" />
                                            {(request.Status === 'B') &&
                                                <button name={m.Seq} className={"btn btn-danger border-secondary font-weight-bold float-md-right col-sm-4 col-xs-12 mt-3 mt-sm-0 p-3" + (this.state.IsTabletView == false ? " w-100" : "")} onClick={this.handleUniformRemoveClick.bind(this)}>
                                                    <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-192-minus-sign.png`} width='20px' className="mr-1" />
                                                    Remove 移除</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                    )
                }
            });

        }

        let domReplacementItems;
        if (this.state.replaceItems) {
            const replaceItems = this.state.replaceItems;

            let row = 0;
            if (this.state.IsMobileView == false) {
                let _accordionId, _headingId, _collapseId, _carouselIndId;
                //  if (this.props.debug) console.log(replaceItems);
                domReplacementItems = replaceItems.map((m) => {

                    // var _existed = this.state.request.RequestItems.find((node) => {
                    //     return (node.UniformCode == m.UniformCode);
                    // });

                    let _subCodeList = m.SubCodeList.map((n) => {
                        return (
                            <div>
                                {n.SubCode} - {n.SubCodeDesc} ({n.SubCodeCollectedQty})
                            </div>
                        )
                    });

                    let _accordionId = "mobDomRepItmAccordion" + row;
                    let _headingId = "mobDomRepItmHeading" + row;
                    let _collapseId = "mobDomRepItmCollapse" + row;
                    let _carouselIndId = "mobDomRep_carouselInd" + row;
                    row++;

                    return (
                        //!_existed &&
                        <tr key={row}>
                            {/* <td>{m.UniformCode} - {m.UniformDesc}</td> */}
                            <td className="align-middle">{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</td>
                            {/* <td className="align-middle">{m.SubCode} - {m.SubCodeDesc} </td> */}
                            <td className="align-middle">{_subCodeList}</td>
                            <td className="align-middle">{m.ReplaceableQty} {m.UnitDesc} / {m.UnitDescZh} </td>
                            <td className="align-middle">
                                {/* <a data-toggle="modal" data-target="#itemImgModal" className="btn btn-secondary center-block"
                                    onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImgIds)}>
                                    <div className="font-weight-bold text-white" >
                                        <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture-w.png`} />
                                    </div>
                                </a> */}
                                {m.ImageList != null && m.ImageList.length > 0 ?
                                    <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >
                                        {/* <ol className="carousel-indicators">
                                            {
                                                m.ImgIds.map((imgId, index) => {
                                                    return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                })
                                            }
                                        </ol> */}
                                        <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                            onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                            {
                                                m.ImageList.map((m2, index) => {
                                                    return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                        <div className="card-header" id={m2.imgId}>
                                                            <div className="col-12 justify-content-center align-self-center">
                                                                    {(() => {
                                                                        const key = `${m.UniformID}_${m2.ImgId}`;
                                                                        const blobUrl = this.state.measurementImages[key];
                                                                        const isLoading = this.state.loadingImages[key];
                                                                        
                                                                        if (!blobUrl && !isLoading) {
                                                                            this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                        }
                                                                        
                                                                        if (isLoading || !blobUrl) {
                                                                            return <span>Loading...</span>;
                                                                        }
                                                                        
                                                                        if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                            return (
                                                                            <img src={blobUrl}
                                                                                    className="d-block w-100 img-thumbnail "
                                                                                style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <a className="card-img-top image1" target="_blank"> {m2.ImgFileName} </a>
                                                                            );
                                                                        }
                                                                    })()}
                                                            </div>
                                                        </div>

                                                    </div>
                                                })
                                            }
                                        </div>
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Previous</span>
                                            </a>
                                        }
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Next</span>
                                            </a>
                                        }
                                    </div>
                                    :
                                    <div className="d-flex justify-content-center">
                                        <img name={m.Seq}
                                            src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                            width='100%' className="img-thumbnail w-100" style={{ maxHeight: "80px", maxWidth: "80px", margin: "0 auto", }}
                                        // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                        />
                                    </div>
                                }
                            </td>
                            <td className="align-middle">  {(request.Status === 'B') &&
                                <button type="button" name={m.Seq} className="btn btn-primary border-secondary" onClick={this.handleReplaceItemAddClick.bind(this)}>
                                    {(request.Status === 'B') &&
                                        <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-191-plus-sign.png`} width='20px' />
                                    }
                                </button>}
                            </td>
                        </tr>
                    );
                });
            } else {
                let _accordionId, _headingId, _collapseId, _carouselIndId;
                domReplacementItems = replaceItems.map((m) => {
                    _accordionId = "mobDomRepItmAccordion" + row;
                    _headingId = "mobDomRepItmHeading" + row;
                    _collapseId = "mobDomRepItmCollapse" + row;
                    _carouselIndId = "mobDomRep_carouselInd" + row;
                    row++;

                    let _subCodeList = m.SubCodeList.map((n) => {
                        return (
                            <div>
                                {n.SubCode} - {n.SubCodeDesc} ({n.SubCodeCollectedQty})
                            </div>
                        )
                    });

                    // Preload images if not already in state
                    if (m.ImageList && m.ImageList.length > 0) {
                        m.ImageList.forEach((m2) => {
                            const key = `${m.UniformID}_${m2.ImgId}`;
                            if (!this.state.measurementImages[key]) {
                                this.loadMeasurementImage(m.UniformID, m2.ImgId);
                            }
                        });
                    }
                        
                    return (
                        <div key={"mobDomRepItm" + row} className="card shadow rounded mt-3 cardView-body-bg-Color" id={_accordionId}>
                            <div className="card-header cardView-header-bg-Color" id={_headingId} style={{ "padding": "0 0 0 0" }}>
                                <h5 className="mb-0 cardView-header-link" style={{ textAlign: 'left' }}>
                                    <a className="btn btn-link w-100 text-white" data-toggle="collapse" data-target={'#' + _collapseId} href={'#' + _collapseId} aria-expanded="true" aria-controls={_collapseId}>
                                        <label className={this.state.IsTabletView ? "card-text h5 font-weight-bold text-white" : "card-text h6 font-weight-bold text-white"}>{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</label>
                                    </a>
                                </h5>
                            </div>
                            <div id={_collapseId} className="collapse " aria-labelledby={_headingId} data-parent="#currHoldItm">
                                {/* data-parent={'#' + _accordionId} */}
                                <div className="card-body text-sm-left " >
                                    <div className="row no-gutters">
                                        <div className={this.state.IsTabletView ? "col-4 my-auto d-flex justify-content-center" : "col-4 my-auto d-flex"} >

                                            {(() => {
                                                if (m.ImageList != null && m.ImageList.length > 0) {
                                                    return (<div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >
                                                        {/* <ol className="carousel-indicators">
                                                            {
                                                                m.ImgIds.map((imgId, index) => {
                                                                    return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                                })
                                                            }
                                                        </ol> */}
                                                        <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                                            onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                                            {
                                                                m.ImageList.map((m2, index) => {
                                                                    return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                                        <div className="card-header" id={m2.imgId}>
                                                                            <div className="col-12 justify-content-center align-self-center text-center">
                                                                                {(() => {
                                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                                    const blobUrl = this.state.measurementImages[key];
                                                                                    const isLoading = this.state.loadingImages[key];
                                                                                    
                                                                                    if (!blobUrl && !isLoading) {
                                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                                    }
                                                                                    
                                                                                    if (isLoading || !blobUrl) {
                                                                                        return <span>Loading...</span>;
                                                                                    }
                                                                                    
                                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                                        return (
                                                                                        <img src={blobUrl}
                                                                                                className="d-block w-100 img-thumbnail "
                                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                                        );
                                                                                    } else {
                                                                                        return (
                                                                                            <a className="card-img-top image1 text-center" alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                                        );
                                                                                    }
                                                                                })()}
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                                <span className="sr-only">Previous</span>
                                                            </a>
                                                        }
                                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                                <span className="sr-only">Next</span>
                                                            </a>
                                                        }
                                                    </div>
                                                    )
                                                } else {
                                                    return (<img name={m.Seq}
                                                        src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                        width='100%' className="img-thumbnail w-100" style={this.state.IsTabletView ? { maxHeight: "150px", maxWidth: "150px", margin: "0 auto", } : { maxHeight: "80px", maxWidth: "80px" }}
                                                    // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                                    />)
                                                }
                                            })()}
                                        </div>
                                        {this.state.IsTabletView ?
                                            <div className="col-8 my-auto">
                                                <div><label className="card-text h5 col-12"><span className="text-muted">On-Hold Size 現有尺碼 (Qty 數量): {_subCodeList}</span></label></div>
                                                <br />
                                                <div><label className="card-text h5 col-12"><span className="text-muted">Replaceable Qty 可更換數量: {m.ReplaceableQty} {m.UnitDesc} / {m.UnitDescZh} </span></label></div>
                                            </div>
                                            :
                                            <div className="col-8 my-auto">
                                                {/* <p className="text-center"><small className="card-text mb-2 text-muted col-12">{m.UniformCode}</small></p> */}
                                                <div className="mt-md-5"><label className="card-text col-12 text-center"><span className="text-muted text-center small">On-Hold Size 現有尺碼 (Qty 數量):</span></label></div>
                                                <div className="mt-md-5"><label className="card-text col-12 text-center"><span className="font-weight-bold text-center">{_subCodeList}</span></label></div>
                                                <div className="mt-md-5"><label className="card-text col-12 text-center"><span className="text-muted text-center small">Replaceable Qty 可更換數量:</span></label></div>
                                                <div className=" mt-md-5"><label className="card-text col-12 text-center"><span className="font-weight-bold text-center">{m.ReplaceableQty} {m.UnitDesc} / {m.UnitDescZh} </span></label></div>
                                            </div>
                                        }
                                    </div>
                                    <hr />
                                    <div className="row no-gutters">
                                        {/* <div className={"col-md-5 col-12 my-auto " + (this.state.IsTabletView == false ? "d-flex justify-content-center" : "")}>
                                            <small className="text-muted">On-Hold Qty 現持有數量: {m.ReplaceableQty}</small>
                                        </div> */}
                                        <div className="col-12">
                                            {(request.Status === 'B') &&
                                                <button type="button" name={m.Seq} className={"btn btn-primary border-secondary font-weight-bold w-100" + (this.state.IsTabletView == false ? " " : " h5 p-3")} onClick={this.handleReplaceItemAddClick.bind(this)}>

                                                    <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-191-plus-sign.png`} width='20px' className="mr-1" />
                                                    Add 添加</button>}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    );
                });
            }
        }

        let domReplacement;
        if (request.RequestType === "RP") {
            if (this.state.IsMobileView == false) {
                domReplacement = (
                    <div className="form-row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                            <label className="text-info font-weight-bold">Replaceable Item(s) 可更換制服 : </label>
                            <br />
                            <div id="replacableTable" className="tableFixHead table-responsive ">
                                <table className="table table-striped dt-responsive w-100 small" >
                                    <tbody>
                                        {domReplacementItems}
                                    </tbody>
                                    <thead >
                                        <tr>
                                            <th scope="col" >Uniform<br />制服</th>
                                            <th scope="col" className="text-nowrap">On-Hold Size (Qty)<br />現有尺碼 (數量)</th>
                                            <th scope="col" className="text-nowrap">Replaceable Qty<br />可更換數量</th>
                                            <th scope="col" >Image<br />圖片</th>
                                            <th scope="col" >Add<br />添加</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <br />
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                            <div className='form-row'>
                                <label>Request Item(s) 申請制服 : </label>
                            </div>
                            {/* <div className="tableFixHead table-responsive font-weight-bold">
                            <table id="replaceRequestTable" className="table table-striped dt-responsive w-100 small" > */}
                            <div className="tableFixHead table-responsive font-weight-bold">
                                <table id="replaceRequestTable" className="table table-striped datatable small dt-responsive w-100">
                                    <tbody>
                                        {domRequestedItems}
                                    </tbody>
                                    <thead >
                                        <tr>
                                            {/* <th >Uniform Code<br />制服編碼</th>
                                            <th >Description<br />項目</th> */}
                                            <th scope="col">Uniform<br />制服</th>
                                            <th scope="col">Image<br />圖片</th>
                                            <th scope="col">Replacement Count<br />可更換限額</th>
                                            <th scope="col" className="text-nowrap">Replaceable Qty<br />可更換數量	</th>
                                            <th scope="col" className="text-nowrap">Qty<br />數量</th>
                                            <th scope="col" className="text-nowrap">Size<br />尺碼</th>
                                            <th scope="col" className="text-nowrap">Reason<br />原因</th>

                                            {(this.existManItm > 0) &&
                                                <th scope="col" className="text-nowrap">Expected Delivery Date<br />預產期</th>
                                            }
                                            <th scope="col">Remove<br />移除</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <br />
                        </div>
                    </div>
                );
            } else {

                domReplacement = (
                    <div>

                        <ul id="uiReplacement" className="nav nav-tabs  tab-fix-top" role="tablist" style={{ display: "flex" }} >
                            <li className="nav-item w-50">
                                <a style={{ display: "flex" }} className={"tabLink-color active w-100 small" + (this.state.IsSmMobileView ? "" : "")} data-toggle="tab" role="tab" aria-controls="currHoldItm" href="#currHoldItm">
                                    <label className="w-100">Replaceable Item(s) <br /> 可更換制服</label>
                                </a>

                            </li>
                            <li id="liReplacementRequestItem" className="nav-item w-50" style={{ display: "flex" }}>
                                <a style={{ display: "flex" }} className={"tabLink-color w-100 small" + (this.state.IsSmMobileView ? "" : "")} data-toggle="tab" role="tab" aria-controls="reqItm" href="#reqItm">
                                    <label id="labelReplacementRequestItem" className="w-100" >Request Item(s) <br /> 申請制服 <span className="badge badge-pill badge-info">{this.state.request.RequestItems.length}</span> </label>
                                </a>
                            </li>
                        </ul>

                        <div className="tab-content">
                            <div id="currHoldItm" className="tab-pane fade show active">
                                <div className="mt-2">
                                    {domReplacementItems}
                                </div>
                            </div>
                            <div id="reqItm" className="tab-pane fade">
                                {(() => {
                                    if (request.RequestItems.length > 0) {
                                        return (<div className="mt-2">
                                            {domRequestedItems}
                                        </div>
                                        )
                                    } else {
                                        return (
                                            <div className="text-center h5" style={{ padding: "150px 0px 150px 0px" }}>
                                                <label>No item(s) selected<br />未選擇制服:</label>
                                            </div>)
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                );
            }
        }

        let domSpecialItems;
        if (this.state.specialItems) {
            const specialItems = this.state.specialItems;
            let row = 0, _accordionId, _headingId, _collapseId;

            if (specialItems.length == 0 && this.state.IsMobileView) {
                return (<div></div>);
            }

            domSpecialItems = specialItems.map((m) => {
                row++;
                if (this.state.IsMobileView == false) {
                    let _accordionId = "mobDomSR_ItmAccordion" + row;
                    let _headingId = "mobDomSR_ItmHeading" + row;
                    let _collapseId = "mobDomSR_Collapse" + row;
                    let _carouselIndId = "mobDomSR_carouselInd" + row;
                    row++;

                    return (
                        //!_existed &&
                        <tr key={row}>
                            {/* <td>{m.UniformCode}</td> */}
                            <td className="align-middle">{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</td>
                            <td className="align-middle">
                                {/* <a data-toggle="modal" data-target="#itemImgModal" className="btn btn-secondary center-block"
                                onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImgIds)}>
                                    <div className="font-weight-bold text-white" >
                                        <img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture-w.png`} />
                                    </div>
                                </a> */}
                                {m.ImageList != null && m.ImageList.length > 0 ?
                                    <div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >
                                        {/* <ol className="carousel-indicators">
                                            {
                                                m.ImgIds.map((imgId, index) => {
                                                    return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                })
                                            }
                                        </ol> */}
                                        <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                            onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                            {
                                                m.ImageList.map((m2, index) => {
                                                    return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                        <div className="card-header" id={m2.imgId}>
                                                            <div className="col-12 justify-content-center align-self-center text-center" >
                                                                {(() => {
                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                    const blobUrl = this.state.measurementImages[key];
                                                                    const isLoading = this.state.loadingImages[key];
                                                                    
                                                                    if (!blobUrl && !isLoading) {
                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                    }
                                                                    
                                                                    if (isLoading || !blobUrl) {
                                                                        return <span>Loading...</span>;
                                                                    }
                                                                    
                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                        return (
                                                                          <img src={blobUrl}
                                                                                className="d-block w-100 img-thumbnail "
                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <a className="card-img-top image1 text-center" style={{ textAlign: 'center' }} alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                        );
                                                                    }
                                                                })()}
                                                                
                                                            </div>
                                                        </div>

                                                    </div>
                                                })
                                            }
                                        </div>
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Previous</span>
                                            </a>
                                        }
                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Next</span>
                                            </a>
                                        }
                                    </div>
                                    :
                                    <div className="d-flex justify-content-center">
                                        <img name={m.Seq}
                                            src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                            width='100%' className="img-thumbnail w-100" style={{ maxHeight: "80px", maxWidth: "80px", margin: "0 auto", }}
                                        // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                        />
                                    </div>
                                }
                            </td>
                            <td className="align-middle">
                                {(request.Status === 'B') &&
                                    <button name={m.Seq} className="btn btn-primary" onClick={this.handleSpecialItemAddClick.bind(this)}>
                                        <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-191-plus-sign.png`} width='20px' />
                                    </button>
                                }
                            </td>
                        </tr>
                    );
                } else {

                    let _accordionId = "mobDomSR_ItmAccordion" + row;
                    let _headingId = "mobDomSR_ItmHeading" + row;
                    let _collapseId = "mobDomSR_Collapse" + row;
                    let _carouselIndId = "mobDomSR_carouselInd" + row;
                    row++;
                    return (
                        <div key={"mobDomReplaceItm" + row} className="card shadow rounded mt-3" id={_accordionId}>
                            {/* <img className="card-img-top" src={`${process.env.PUBLIC_URL}/Images/Penguins_300x225.jpg`} alt="Card image cap"></img> */}
                            <div className="card-header cardView-header-bg-Color" id={_headingId} style={{ "padding": "0 0 0 0" }}>
                                <h5 className="mb-0 cardView-header-link" style={{ textAlign: 'left' }}>
                                    <a className="btn btn-link w-100 text-white" data-toggle="collapse" data-target={'#' + _collapseId} href={'#' + _collapseId} aria-expanded="true" aria-controls={_collapseId}>
                                        <label className={this.state.IsTabletView ? "card-text h5 font-weight-bold text-white" : "card-text h6 font-weight-bold text-white"}>{m.UniformDesc} {m.UniformDesc != m.UniformDescZh ? <br /> : ""} {m.UniformDesc != m.UniformDescZh ? m.UniformDescZh : ""}</label>
                                    </a>
                                </h5>
                            </div>
                            <div id={_collapseId} className="collapse " aria-labelledby={_headingId} data-parent="#currHoldItm">
                                {/* data-parent={'#' + _accordionId} */}
                                <div className="card-body cardView-body-bg-Color text-sm-left pb-1">
                                    <div className="row no-gutters">
                                        <div className="col-5 my-auto d-flex justify-content-center">
                                            {(() => {
                                                if (m.ImageList != null && m.ImageList.length > 0) {
                                                    return (<div id={_carouselIndId} className="carousel slide" data-ride="carousel" data-interval="false"  >
                                                        {/* <ol className="carousel-indicators">
                                                            {
                                                                m.ImgIds.map((imgId, index) => {
                                                                    return <li key={_carouselIndId + "carouLi" + index} data-target={"#" + _carouselIndId} data-slide-to={index} className={"carousel-indicators-shape " + (index == 0 ? "active" : "")}></li>
                                                                })
                                                            }
                                                        </ol> */}
                                                        <div className="carousel-inner" data-toggle="modal" data-target="#itemImgModal"
                                                            onClick={this.PassParmToModel.bind(this, m.UniformDesc, m.UniformID, m.ImageList)} >
                                                            {
                                                                m.ImageList.map((m2, index) => {
                                                                    return <div key={_carouselIndId + "carouselItem" + index} className={"carousel-item " + (index == 0 ? "active" : "")}>
                                                                        <div className="card-header " id={m2.imgId}>
                                                                            <div className="col-12 justify-content-center align-self-center text-center" >
                                                                               
                                                                                {(() => {
                                                                                    const key = `${m.UniformID}_${m2.ImgId}`;
                                                                                    const blobUrl = this.state.measurementImages[key];
                                                                                    const isLoading = this.state.loadingImages[key];
                                                                                    
                                                                                    if (!blobUrl && !isLoading) {
                                                                                        this.loadMeasurementImage(m.UniformID, m2.ImgId);
                                                                                    }
                                                                                    
                                                                                    if (isLoading || !blobUrl) {
                                                                                        return <span>Loading...</span>;
                                                                                    }
                                                                                    
                                                                                    if (m2.ImgFileName.toLowerCase().lastIndexOf(".pdf") <= 0) {
                                                                                        return (
                                                                                        <img src={blobUrl}
                                                                                                className="d-block w-100 img-thumbnail "
                                                                                            style={{ maxHeight: "100px", maxWidth: "100px", margin: "0 auto", }} />
                                                                                        );
                                                                                    } else {
                                                                                        return (
                                                                                            <a className="card-img-top image1 text-center" alt="Card image cap" target="_blank"> {m2.ImgFileName} </a>
                                                                                        );
                                                                                    }
                                                                                })()}


                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                                            <a className="carousel-control-prev" href={"#" + _carouselIndId} role="button" data-slide="prev">
                                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                                <span className="sr-only">Previous</span>
                                                            </a>
                                                        }
                                                        {m.ImageList != null && m.ImageList.length > 1 &&
                                                            <a className="carousel-control-next" href={"#" + _carouselIndId} role="button" data-slide="next">
                                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                                <span className="sr-only">Next</span>
                                                            </a>
                                                        }
                                                    </div>
                                                    )
                                                } else {

                                                    return (<img name={m.Seq}
                                                        src={`${process.env.PUBLIC_URL}/Images/no-image.png`}
                                                        width='100%' className="img-thumbnail w-100" style={this.state.IsTabletView ? { maxHeight: "150px", maxWidth: "150px", margin: "0 auto", } : { maxHeight: "80px", maxWidth: "80px" }}
                                                    // onError={e => { if (e.target.src !== {`${process.env.PUBLIC_URL}/Images/no-image.png`}) { e.target.src = {`${process.env.PUBLIC_URL}/Images/no-image.png`} } }}
                                                    />)
                                                }
                                            })()}
                                        </div>
                                        <div className="col-7 my-auto">
                                            {(request.Status === 'B') &&
                                                <button name={m.Seq} className="btn btn-primary border-secondary font-weight-bold float-right p-3" onClick={this.handleSpecialItemAddClick.bind(this)}>
                                                    <img name={m.Seq} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-191-plus-sign.png`} width='20px' />
                                                    Add 添加</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }
            });
        }


        let domSpecial;
        if (request.RequestType === 'S') {
            if (this.state.IsMobileView == false) {
                domSpecial = (
                    <div className="form-row">
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                            <label className="text-primary font-weight-bold">Special Request Item(s) 特別申請制服 : </label>
                            <div className="tableFixHead table-responsive">
                                <table className="table table-striped dt-responsive w-100 small" >
                                    <tbody>
                                        {domSpecialItems}
                                    </tbody>
                                    <thead >
                                        <tr>
                                            <th scope="col-sm">Uniform<br />制服</th>
                                            {/* <th scope="col-sm">Description<br />項目</th> */}
                                            <th scope="col-sm">Image<br />圖片</th>
                                            <th scope="col-sm">Add<br />添加</th>
                                        </tr>
                                    </thead>

                                </table>
                            </div>
                            <br />
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-7">
                            <label>Request Item(s) 申請制服 : </label>
                            <div id="specialRequestTable" className="tableFixHead table-responsive font-weight-bold">
                                <table className="table table-striped dt-responsive w-100 small" >
                                    <tbody>
                                        {domRequestedItems}
                                    </tbody>
                                    <thead >
                                        <tr>
                                            {/* <th scope="col-sm">Uniform Code<br />制服編碼</th>
                                            <th scope="col-sm">Description<br />項目</th> */}
                                            <th scope="col-sm">Uniform<br />制服</th>
                                            <th scope="col-sm">Image<br />圖片</th>
                                            <th scope="col-sm">Qty<br />數量</th>
                                            <th scope="col-sm">Size<br />尺碼</th>
                                            {(this.existManItm > 0) &&
                                                <th scope="col-s">Expected Delivery Date<br />預產期</th>
                                            }
                                            <th scope="col-sm">Remove<br />移除</th>
                                        </tr>
                                    </thead>

                                </table>
                            </div>
                            <br />
                        </div>
                    </div>
                );
            } else {
                domSpecial = (
                    <div>
                        <ul id="uiSpecial" className="nav nav-tabs tab-fix-top" role="tablist">
                            <li className="nav-item w-50" style={{ display: "flex" }}>
                                <a style={{ display: "flex" }} className={"tabLink-color active w-100 small" + (this.state.IsSmMobileView ? "" : "")} data-toggle="tab" role="tab" aria-controls="currHoldItm" href="#currHoldItm">
                                    <label className="w-100">Special Request Item(s) <br /> 特別申請制服</label>
                                </a>
                            </li>
                            <li id="liSpecialRequestItem" className="nav-item w-50" style={{ display: "flex" }}>
                                <a style={{ display: "flex" }} className={"tabLink-color w-100 small" + (this.state.IsSmMobileView ? "" : "")} data-toggle="tab" role="tab" aria-controls="reqItm" href="#reqItm">
                                    <label className="w-100">Request Item(s) <br /> 申請制服  <span className="badge badge-pill badge-info">{this.state.request.RequestItems.length}</span></label>
                                </a>
                            </li>
                        </ul>



                        <div className="tab-content">
                            <div id="currHoldItm" className="tab-pane fade show active">
                                <div className="mt-2">
                                    {domSpecialItems}
                                </div>
                            </div>
                            <div id="reqItm" className="tab-pane fade">
                                {(() => {
                                    if (request.RequestItems.length > 0) {
                                        return (<div className="mt-2">
                                            {domRequestedItems}
                                        </div>)
                                    } else {
                                        return (
                                            <div className="text-center h5" style={{ padding: "150px 0px 150px 0px" }}>
                                                <label>No item(s) selected<br />未選擇制服</label>
                                            </div>)
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                );
            }
        }


        let attachments = this.state.request.Attachments;
        let domAttachments;
        if ((attachments) && (attachments.length > 0)) {
            domAttachments = attachments.map((m) => {
                const blobUrl = this.state.viewattachment[m.AttachmentID];
                if (!blobUrl && m.AttachmentID) {
                    this.loadViewattachment(m.AttachmentID);
                }
                return (
                    <div className="card" key={m.AttachmentID}>
                        <div className="card-header d-flex" id="headingOne">
                            <div>{m.Filename}</div>
                            <div className="ml-auto">
                                <a className="btn btn-link" data-toggle="collapse" href={'#collapse' + m.AttachmentID} role="button" aria-expanded="false" aria-controls={'collapse' + m.AttachmentID}><img src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-139-picture.png`} width='18px' /></a>
                                <button name={m.AttachmentID} className="btn" onClick={this.handleDeleteAttachmentClick.bind(this)}  >
                                    <img name={m.AttachmentID} src={`${process.env.PUBLIC_URL}/Images/glyphicons/glyphicons-17-bin.png`} width='18px' />
                                </button>
                            </div>
                        </div>

                        <div id={'collapse' + m.AttachmentID} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div className="card-body">
                                <div className="col-12 d-flex justify-content-center align-self-center" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }} >
                                    {m.Filename.toLowerCase().lastIndexOf(".pdf") <= 0 ? (
                                        blobUrl ? (
                                            <a target="_blank" href={blobUrl} rel="noopener noreferrer" download={stripSurroundingQuotes(m.Filename)}>
                                                <img className="img-thumbnail text-center"  src={blobUrl} alt="Card image cap"/>
                                            </a>
                                        ) : (
                                            <div>Loading image...</div>
                                        )
                                    ) : (
                                        blobUrl ? (
                                            <a className="card-img-top image1 text-center" href={blobUrl} alt="Card image cap" download={stripSurroundingQuotes(m.Filename)}
                                               target="_blank" rel="noopener noreferrer">Click to preview {m.Filename} </a>
                                        ) : (
                                            <div>Loading PDF...</div>
                                        )
                                    )}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })
        }


        let source;
        let typeFilter = Object.assign([], this.state.Source);
        // if (request.RequestType === "RP") {
        //     let index = typeFilter.indexOf(".pdf");
        //     typeFilter.splice(index, 1);
        // }
        let type = "";
        typeFilter.map((m) => {
            return type += (m + "/");
        });
        //console.log(typeFilter);

        if (request.RequestType === "RP") {
            // let index = typeFilter.indexOf(".pdf");
            // typeFilter.splice(index, 1);

            source = (
                <label>Supporting Photo (s) 相關相片: {this.state.IsMobileView ? <br /> : ''} <label className={this.state.IsMobileView ? 'small' : ''}><i>(Format 格式: {type} , Size 檔案大小 : Under {this.state.SizeLimitInMB} MB)</i></label></label>
            )
        }
        else if (request.RequestType === 'S') {
            source = (
                <label>Supporting Document (s) with Approval  已獲批核之相關文件: {this.state.IsMobileView ? <br /> : ''} <label className={this.state.IsMobileView ? 'small' : ''}><i>(Format 格式: {type} , Size 檔案大小 : Under {this.state.SizeLimitInMB} MB)</i></label></label>
            )
        }
        else {
            source = (
                <label></label>
            )
        }


        return (
            <div className="card">
                <div id="collapseThreeXXXX" className="collapseXXXX" aria-labelledby="headingThreeXXX" data-parent="#accordionExample" style={{ height: '80vh', overflowY: 'scroll', overflowX: 'hidden' }}>
                    {/* style={{ maxHeight: '90vh', overflowY: 'scroll', overflowX: 'hidden' }} */}


                    <div className={"card-body mediumText " + (this.state.IsMobileView ? '' : '')} style={this.state.IsMobileView ? { overflowY: 'scroll', overflowX: 'hidden', height: '100%', padding: '0px 5px 5px 5px' } : { height: '80%' }} >
                        {/* <div className="card-body mediumText card-body-wider" style={{ minHeight: "100vh" }}> */}
                        <div className="form-row">
                            <div className="col-12 col-md-6 pl-3 pt-3">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4"><label>Staff Name / Staff ID 姓名 / 員工編號 : </label></div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 font-weight-bold h5">{this.state.staff.LastName} {this.state.staff.FirstName} {this.state.staff.PrefName != null ? ',' + this.state.staff.PrefName : ''} ({this.state.staff.ERN})</div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 pl-3 pt-3">
                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-3 mt-md-0"><label>Department  部門 : </label></div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 font-weight-bold h5">{this.state.staff.Department}</div>
                                </div>
                            </div>
                        </div>
                        <hr />

                        {/* <div className="form-row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2"><label>Department  部門: </label></div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 font-weight-bold">{this.state.staff.Department}</div>
                        </div>
                        <br /> */}


                        <div className="form-row pl-2">
                            <div className="col-12 col-md-3">
                                <label>Request Type  申請原因 : </label>
                            </div>
                            <div className="col-12 col-md-9">
                                <select id="select_Request_Reason" className="form-control custom-select font-weight-bold" value={request.RequestType} onChange={this.handleRequestTypeChange.bind(this)} >
                                    <option value="RP">Replacement (RP)  更換</option>
                                    <option value="S">Special Request (S)  特別申請</option>
                                </select>

                            </div>
                        </div>


                        {/* <br style={this.state.IsMobileView ? { display: "none" } : {}} /> */}


                        {/* <div className="col-12 bg-white" />
                        <div className="col-12 bg-white" />
                        <div className="col-12 gap-line-grey" />
                        <div className="col-12 bg-white" />
                        <div className="col-12 bg-white" /> */}



                        <br />

                        {this.state.request.RequestItems != null && this.state.request.RequestItems != [] && this.state.request.RequestItems.length > 0 && !(this.state.allowSave) &&
                            //(!(this.state.allowSave) || needEvidence )
                            <div id="divAlert" className={'form-row alert alert-warning order-dark text-secondary ' + (this.state.IsMobileView ? "" : "sticky-top")} role="alert">
                                <label className={this.state.IsMobileView && !this.state.IsTabletView ? "small" : ""}>Please handle the input error by / 請根據以下指引, 修正輸入錯誤:
                                    <br />
                                    <span>&#42;</span> <label className="text-warning font-weight-bold">Yellow/黃色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Request Qty MORE THEN Replaceable Qty / 申請數量 多於 可更換數量 </label>
                                    <br />
                                    <span>&#42;</span> <label className="text-danger font-weight-bold">Red/紅色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Reach Max. Replacement Count / 已達最高可更換限額 </label>
                                    <br />
                                    <span>&#42;</span> <label className="font-weight-bold" style={{ color: 'OrangeRed' }}>Orange/橙色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Evidence or Approval Letter is needed / 尚未上載 附圖 或 批准信</label>
                                    <br />
                                    <span>&#42;</span> <label className="font-weight-bold text-info" >Blue/藍色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Input wrong or not input Expected Delivery Date  / 輸入錯誤或沒有輸入預產期</label>
                                </label>
                            </div>

                        }

                        {/* <div className='form-row alert alert-warning sticky-top border-dark text-secondary' role="alert">
                            <label>Please handle the input error by / 請根據以下指引, 修正輸入錯誤:
                                <br />
                                <span>&#42;</span> <label className="text-warning font-weight-bold">Yellow/黃色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Request Qty MORE THEN On-Hold Qty (Replaceable) / 申請數量 多於 現持有數量 (可更換) </label>
                                <br />
                                <span>&#42;</span> <label className="text-danger font-weight-bold">Red/紅色</label><label className="font-weight-bold"> <span>&#xA0;</span> - Reach Max. Replacement Count / 已達最高可更換限額 </label>
                            </label>
                        </div> */}

                        {/* <div className='form-row alert alert-warning' role="alert">
                            <label className="font-weight-bold">Please handle the input error by  請根據指引修正錯誤輸入:  
                            <span>&#xA0;</span>
                                                                    <span>&#42;</span> <label className="text-warning">Yellow/黃色 - Request Qty <span>&#x3e;</span> On-Hold Qty</label>
                                                                    <span>&#xA0;</span>
                                                                    <span>&#42;</span> <label className="text-danger">Red/紅色 - Reach Max. Replacement Count </label>                                                                 
                            </label>
                        </div> */}


                        {this.renderItemImgModal()}
                        <div id="divbreak" />
                        {domReplacement}
                        {domSpecial}

                        <hr />
                        <div className="form-row"
                            style={attachments.length <= 0
                                && this.state.request.RequestItems != null && this.state.request.RequestItems != [] && this.state.request.RequestItems.length > 0 && this.state.needEvidence ?
                                { color: 'OrangeRed', fontWeight: 'bold' } : {}
                            }>

                            <div className="col-sm-12">
                                {source}
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                                <div className="custom-file" id="divAttachment">
                                    <input type="file" className="custom-file-input" id="customFile" accept={"image/*, .pdf"} /*accept={request.RequestType === "RP" ? "image/*" : "image/*, .pdf"}*/ onChange={this.handleFileUploadChange.bind(this)} />
                                    <label className="custom-file-label" htmlFor="customFile">{this.state.UploadAlert}</label>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8">
                                {this.state.IsMobileView ? <br /> : ''}
                                {domAttachments}
                            </div>


                        </div>
                        <div className="form-row">&nbsp;
                        </div>
                        <div className="form-row">
                            <div className="mx-auto">
                                {(this.state.allowSave) && (request.Status === 'B') &&
                                    <button className="btn btn-primary" onClick={this.handleSubmitClick.bind(this)} >Submit 提交</button>
                                }
                                <span>&#xA0;</span>
                                {this.state.submitResult != null && this.state.submitResult.length > 0 && <button className="btn btn-secondary" type="button" data-toggle="collapse" data-target="#collapseOne" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Start Over 重新開始</button>}
                                {this.state.IsMobileView ? <br /> : <span>&#xA0;</span>}
                                <span className='font-weight-bold text-success'>{this.state.submitResult}</span>
                            </div>

                        </div>
                        <br />
                    </div>
                </div>
                <a id="btnBottom" href="#divAttachment" style={this.state.IsMobileView ? {} : { display: 'none' }}>V</a>
            </div>



        )
    }
}

export default Application;